import axios from "axios";
export const getUser = async (params = {}) => {
  const func = async () => {
    const query = params.query ? `?${params.query}` : "";
    return axios.get(`${process.env.REACT_APP_USER_ENDPOINT}${query}`, {
      headers: {
        Authorization: sessionStorage.getItem("jwt"),
      },
    });
  };

  return await func();
};

export const getUserData = async (query) => {
  const response = await getUser({ query });
  return JSON.parse(response.data.body).data.filter((f) => f.trade_name);
};


export const fetchCategories = async (query) => {
    const config = { headers: { Authorization: sessionStorage.getItem("jwt") } };
    const response = await axios.get(`${process.env.REACT_APP_CATEGORY_ENDPOINT}${query}`, config);
    return JSON.parse(response.data.body).data;
  };
  

export const transformDepotData = (depotData) => {
  let options = [];
  let index = 0;

  const recursiveTransform = (obj, depotLabel = "", categoryLabel = "") => {
    Object.keys(obj).forEach((key) => {
      if (obj[key].sub_category) {
        if (!depotLabel) {
          recursiveTransform(obj[key].sub_category, key);
        } else if (!categoryLabel) {
          recursiveTransform(obj[key].sub_category, depotLabel, key);
        } else {
          recursiveTransform(obj[key].sub_category, depotLabel, categoryLabel);
        }
      } else if (obj[key].id_category) {
        options.push({
          depot: depotLabel,
          category: categoryLabel,
          type: key,
          id_category: obj[key].id_category,
          index: index++,
        });
      }
    });
  };

  recursiveTransform(depotData);
  return options;
};